import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';

const LOGO_URL = "/logo.png";

export default function Footer() {
  return (
    <footer className="bg-[#0f172a] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Meet For Mahjong" className="h-20 w-20 rounded-full shadow-lg" />
              <span className="font-bold text-xl leading-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>Meet For<br />Mahjong</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Connecting American Mahjong players with local players across the United States.
            </p>

            {/* Social — follow CTAs duplicated in Get Started column for
                visibility but keeping them here too since visitors who scroll
                past the description naturally look for them next. */}
            <div>
              <p className="text-xs uppercase tracking-wide text-slate-500 font-semibold mb-3">Follow us</p>
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/meetformahjong"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow Meet For Mahjong on Facebook"
                  className="w-10 h-10 rounded-full bg-slate-800 hover:bg-[#1877F2] flex items-center justify-center transition-colors"
                  data-testid="footer-facebook"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="https://www.instagram.com/meetformahjong"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow Meet For Mahjong on Instagram"
                  className="w-10 h-10 rounded-full bg-slate-800 hover:bg-[#E4405F] flex items-center justify-center transition-colors"
                  data-testid="footer-instagram"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-[#56dfb4]" style={{ fontFamily: 'Outfit, sans-serif' }}>Quick Links</h4>
            <ul className="space-y-2">
              {[
                { to: '/about', label: 'About Us' },
                { to: '/how-it-works', label: 'How It Works' },
                { to: '/pricing', label: 'Membership' },
                { to: '/faq', label: 'FAQ' },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 hover:text-white text-sm transition-colors">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4 text-[#56c6df]" style={{ fontFamily: 'Outfit, sans-serif' }}>Support</h4>
            <ul className="space-y-2">
              {[
                { to: '/contact', label: 'Contact Us' },
                { to: '/terms-and-conditions', label: 'Terms & Conditions' },
                { to: '/privacy-policy', label: 'Privacy Policy' },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 hover:text-white text-sm transition-colors" data-testid={`footer-link-${link.to.replace(/\//g, '')}`}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Get Started */}
          <div>
            <h4 className="font-semibold mb-4 text-[#df5681]" style={{ fontFamily: 'Outfit, sans-serif' }}>Get Started</h4>
            <p className="text-slate-400 text-sm mb-4">Ready to find your next Mahjong group?</p>
            <Link
              to="/register"
              className="inline-block px-6 py-2.5 bg-[#56dfb4] text-slate-900 rounded-full text-sm font-medium hover:bg-[#3ec49b] transition-colors"
            >
              Join Free
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 text-center text-slate-500 text-sm">
          &copy; {new Date().getFullYear()} Meet For Mahjong. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
